//export const API_BASE_URL = 'https://ec2-52-194-214-218.ap-northeast-1.compute.amazonaws.com';
//export const API_BASE_URL = 'http://localhost:10000';  
export const API_BASE_URL = "https://api.hostelandpg.com";
